import { Controller } from "@hotwired/stimulus";

// Auto-resizes a cross-origin iframe to its content height — but only if the
// embedded page cooperates by posting its height. Progressive enhancement:
// without a message it keeps the CSS fallback height (and internal scroll).
//
// The embedded page (auth.auditbadger.com/legal/privacy) must post messages
// like: parent.postMessage({ type: "auditbadger:resize", height: <px> }, "*")
export default class extends Controller {
  static targets = ["frame"];
  static values = { origin: String };

  connect() {
    this.onMessage = this.onMessage.bind(this);
    window.addEventListener("message", this.onMessage);
  }

  disconnect() {
    window.removeEventListener("message", this.onMessage);
  }

  onMessage(event) {
    if (this.hasOriginValue && event.origin !== this.originValue) return;

    const data = event.data;
    if (!data || data.type !== "auditbadger:resize") return;

    const height = parseInt(data.height, 10);
    if (Number.isFinite(height) && height > 0 && this.hasFrameTarget) {
      this.frameTarget.style.height = `${height}px`;
    }
  }
}
